import type { Template } from "@/types";

export const PO_03_H1_V2: Template[] = [
{
    id: "po-03-h1v2-01",
    name: "PO 01 - H1V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h1_v2_01.png",
    size: [1136, 854],
    style: {},
        slots: [
            { id: "1", x: 50, y: 226, width: 514, height: 403, rotation: 0, imageRotation: 0 },
            { id: "2", x: 572, y: 226, width: 253, height: 403, rotation: 0, imageRotation: 0 },
            { id: "3", x: 833, y: 226, width: 253, height: 403, rotation: 0, imageRotation: 0 }
        ],
},

{
    id: "po-03-h1v2-02",
    name: "PO 02 - H1V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h1_v2_02.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 49, y: 226, width: 254, height: 403, rotation: 0, imageRotation: 0 },
        { id: "2", x: 311, y: 226, width: 514, height: 403, rotation: 0, imageRotation: 0 },
        { id: "3", x: 833, y: 226, width: 254, height: 403, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h1v2-03",
    name: "PO 03 - H1V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h1_v2_03.png",
    size: [1136, 854],
    style: {},
    slots: [     
        { id: "1", x: 67, y: 258, width: 213, height: 337, rotation: 0, imageRotation: 0 },
        { id: "2", x: 288, y: 258, width: 213, height: 337, rotation: 0, imageRotation: 0 },
        { id: "3", x: 628, y: 258, width: 446, height: 337, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h1v2-04",
    name: "PO 04 - H1V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h1_v2_04.png",
    size: [1136, 854],
    style: {},
    slots: [       
        { id: "1", x: 64, y: 77, width: 196, height: 346, rotation: 0, imageRotation: 0 },
        { id: "2", x: 64, y: 431, width: 196, height: 346, rotation: 0, imageRotation: 0 },
        { id: "3", x: 268, y: 77, width: 803, height: 700, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h1v2-05",
    name: "PO 05 - H1V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h1_v2_05.png",
    size: [1136, 854],
    style: {},
    slots: [      
        { id: "1", x: 114, y: 146, width: 176, height: 277, rotation: 0, imageRotation: 0 },
        { id: "2", x: 114, y: 431, width: 176, height: 277, rotation: 0, imageRotation: 0 },
        { id: "3", x: 298, y: 146, width: 724, height: 562, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h1v2-06",
    name: "PO 06 - H1V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h1_v2_06.png",
    size: [1136, 854],
    style: {},
    slots: [     
        { id: "1", x: 186, y: 77, width: 196, height: 346, rotation: 0, imageRotation: 0 },
        { id: "2", x: 186, y: 431, width: 196, height: 346, rotation: 0, imageRotation: 0 },
        { id: "3", x: 604, y: 241, width: 497, height: 373, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h1v2-07",
    name: "PO 07 - H1V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h1_v2_07.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 64, y: 77, width: 804, height: 700, rotation: 0, imageRotation: 0 },
        { id: "2", x: 876, y: 77, width: 196, height: 346, rotation: 0, imageRotation: 0 },
        { id: "3", x: 876, y: 431, width: 196, height: 346, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h1v2-08",
    name: "PO 08 - H1V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h1_v2_08.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 115, y: 146, width: 723, height: 562, rotation: 0, imageRotation: 0 },
        { id: "2", x: 846, y: 146, width: 176, height: 277, rotation: 0, imageRotation: 0 },
        { id: "3", x: 846, y: 431, width: 176, height: 277, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h1v2-09",
    name: "PO 09 - H1V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h1_v2_09.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 61, y: 258, width: 446, height: 337, rotation: 0, imageRotation: 0 },
        { id: "2", x: 635, y: 258, width: 213, height: 337, rotation: 0, imageRotation: 0 },
        { id: "3", x: 856, y: 258, width: 213, height: 337, rotation: 0, imageRotation: 0 }
    ],
}
];